import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';

import Criterium from '@hydra/common/criterium/Criterium';

export const MobileFontsize = ({ criterium }) => {
  const { data, url } = criterium;

  const { pageHasLegibleText, viewport } = data;
  let content;

  if (viewport && viewport.isPresent === false) {
    content = 'mobile_fontsize_viewport_not_specified';
  } else if (viewport && viewport.isValid === false) {
    content = 'mobile_fontsize_viewport_invalid';
  } else {
    content = pageHasLegibleText ? 'mobile_fontsize_ok' : 'mobile_fontsize_ko';
  }

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      <Translate content={content} />
    </Criterium>
  );
};

MobileFontsize.propTypes = {
  criterium: PropTypes.shape({
    url: PropTypes.string,
    data: PropTypes.shape({
      viewport: PropTypes.shape({
        isPresent: PropTypes.bool,
        isValid: PropTypes.bool
      }),
      pageHasLegibleText: PropTypes.bool
    })
  })
};

export default React.memo(MobileFontsize);
